import isNil from 'lodash/isNil';
import { isNumeric } from '../../../js/app/react/validators';

export const isChildSelected = childFirstName => () => {
  if (!childFirstName || childFirstName.length <= 0) {
    return ['Please enter a name'];
  }
  return [];
};

export const ageValidator = age => () => {
  if (!isNumeric(age) || +age < 1 || +age > 120) {
    return ['Please enter an age between 1 and 120'];
  }
  return [];
};

export const yearsValidator = amount => () => {
  if (!isNumeric(amount) || +amount < 1 || +amount > 20) {
    return ['Please enter a valid number of years between 1 and 20'];
  }
  return [];
};

export const schoolSelected = schoolId => () => {
  if (schoolId || schoolId === 0) {
    return [];
  }
  return ['Please select the type of school'];
};

export const schoolTuition = tuition => () => {
  if (!isNumeric(tuition) || +tuition < 0 || tuition <= 0) {
    return ['Please specify a cost'];
  }
  return [];
};

export const isSpecificSchoolValidator =
  isSpecificSchool => () => (isNil(isSpecificSchool) ? ['Please select an option'] : []);

export const schoolSearchValidator = schoolName => () => (!schoolName ? ['Please select a school'] : []);
